<template lang="pug">
.update-card-container(:style="bg")
  beforeUpated(v-if="before"
  :beforeCardInfo="beforeCardInfo"
  :afterCardInfo="afterCardInfo"
  :countDown="countDown"
  :upgradeCardInfo="upgradeCardInfo"
  :userNewId="userNewId"
  :activeId="activeId"
  :businessId="businessId"
  :beforeUserCardId="beforeUserCardId"
  @reload="getData"
  @updateError="updateError")
  updated(v-if="after"
  :afterCardInfo="afterCardInfo"
  :upgradeCardInfo="upgradeCardInfo"
  :businessId="businessId"
  :beforeUserCardId="beforeUserCardId")
</template>
<script>
import { getCardInfo } from '@/api/update-card.js';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getTokenAndLocation,
} from '@/utils';
import beforeUpated from './components/beforeUpated.vue';
import Updated from './components/updated.vue';

export default {
  components: {
    beforeUpated,
    Updated,
  },
  data() {
    return {
      before: false,
      after: false,
      UpdatedBG: 'background-image: url(https://m.hellobike.com/resource/helloyun/wb23235/jtIv-_2.png?x-oss-process=image/quality,q_80);',
      beforeBg: '  background-image: url(https://m.hellobike.com/resource/helloyun/wb23235/i-vj2_1.png?x-oss-process=image/quality,q_80);',
      errorBg: 'background-image: url(https://m.hellobike.com/resource/helloyun/wb23235/bHfaH_3.png?x-oss-process=image/quality,q_80);',
      bg: '',
      afterCardInfo: {},
      beforeCardInfo: {},
      businessId: null,
      beforeUserCardId: null,
      userNewId: null,
      activeId: null,
    };
  },
  created() {
    this.getData();
  },
  destroyed() {
    UBT.pageViewOut({
      pageId: 'platform_cardupdate_trans',
      categoryId: 'platform',
      businessInfo: {
        bizType: this.businessId - 1,
      },
    });
  },
  methods: {
    getStyle() {
    },
    async  getData() {
      const { token } = await getTokenAndLocation();
      try {
        const res = await getCardInfo({
          token,
        });
        UBT.pageView({
          pageId: 'platform_cardupdate_trans',
          categoryId: 'platform',
          businessInfo: {
            bizType: this.businessId - 1,
          },
        });
        if (!res.data.afterCardInfo && !res.data.beforeCardInfo) {
          this.bg = this.errorBg;
          this.after = false;
          this.before = false;
          UBT.moduleExpose({
            pageId: 'platform_cardupdate_trans',
            categoryId: 'platform',
            moduleId: 'platform_cardupdate_failed',
            contentId: 'platform_cardupdate_failed',
            exposureTimes: 1,
            businessInfo: {
              bizType: this.businessId - 1,
            },
          });
        } else if (res.data.afterCardInfo && Object.keys(res.data.afterCardInfo).length > 0
        && !res.data.beforeCardInfo) {
          this.after = true;
          this.bg = this.UpdatedBG;
          this.before = false;
          this.businessId = res.data.afterCardInfo.businessId;
          UBT.moduleExpose({
            pageId: 'platform_cardupdate_trans',
            categoryId: 'platform',
            moduleId: 'platform_cardupdate_download',
            contentId: 'platform_cardupdate_download',
            exposureTimes: 1,
            businessInfo: {
              bizType: this.businessId - 1,
            },
          });
        } else {
          this.bg = this.beforeBg;
          this.after = false;
          this.before = true;
          this.businessId = res.data.afterCardInfo.businessId;
          UBT.moduleExpose({
            pageId: 'platform_cardupdate_trans',
            categoryId: 'platform',
            moduleId: 'platform_cardupdate_button',
            contentId: 'platform_cardupdate_button',
            exposureTimes: 1,
            businessInfo: {
              bizType: this.businessId - 1,
            },
          });
          UBT.moduleExpose({
            pageId: 'platform_cardupdate_trans',
            categoryId: 'platform',
            moduleId: 'platform_cardupdate_show',
            contentId: 'platform_cardupdate_show',
            exposureTimes: 1,
            businessInfo: {
              bizType: this.businessId - 1,
            },
          });
        }

        this.beforeCardInfo = res.data.beforeCardInfo;
        this.afterCardInfo = res.data.afterCardInfo;
        this.countDown = res.data.countDown;
        this.upgradeCardInfo = res.data.upgradeCardInfo;
        this.beforeUserCardId = res.data.beforeUserCardId;
        this.userNewId = res.data.userNewId;
        this.activeId = res.data.activeId;
      } catch {
        this.bg = this.errorBg;
        this.after = false;
        this.before = false;
        UBT.pageView({
          pageId: 'platform_cardupdate_trans',
          categoryId: 'platform',
          businessInfo: {
            bizType: this.businessId - 1,
          },
        });
        UBT.moduleExpose({
          pageId: 'platform_cardupdate_trans',
          categoryId: 'platform',
          moduleId: 'platform_cardupdate_failed',
          contentId: 'platform_cardupdate_failed',
          exposureTimes: 1,
          businessInfo: {
            bizType: this.businessId - 1,
          },
        });
      }
    },
    updateError() {
      this.bg = this.errorBg;
      this.after = false;
      this.before = false;
    },
  },
};
</script>
<style lang="less" scoped>
.update-card-container {
  background-size: 100% 100%;
  width: 100%;
  height: 100%;

  .before-update {
    padding-top: 2.03rem;

    .top-business-line {
      display: flex;
      justify-content: space-between;
      margin: 0 0.28rem 0 0.36rem;

      .left-business {
        width: 50%;
        text-align: center;
        color: #e2f3ff;
        font-family: Inter, sans-serif;
        font-size: 0.11rem;
        font-weight: 400;
        line-height: 0.13rem;
        margin-top: 0.29rem;
        margin-left: 0.02rem;
      }

      .right-business {
        width: 60%;
        text-align: center;
        color: #e2f3ff;
        font-family: Inter, sans-serif;
        font-size: 0.11rem;
        font-weight: 400;
        line-height: 0.13rem;
      }
    }

    .middle-times-line {
      display: flex;
      justify-content: space-between;
      margin: 0.01rem 0.5rem 0 0.7rem;

      .middle-times {
        margin-right: 0.1rem;
        font-family: Alibaba PuHuiTi, sans-serif;
        font-size: 0.16rem;
        font-weight: 700;
        line-height: 0.22rem;
        color: #fff;
      }

      .left-times {
        margin-top: 0.3rem;
        width: 0.74rem;
        text-align: center;

        .left-times-top {
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.18rem;
          font-weight: 700;
          line-height: 0.247rem;
          color: #47a7ff;
        }

        .left-times-bottom {
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
          line-height: 0.164rem;
          color: #86cafe;
          margin-top: 0.06rem;
        }
      }

      .right-times {
        margin-top: 0.1rem;

        .right-times-top {
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.24rem;
          font-weight: 900;
          line-height: 0.33rem;
          color: #fff;

          span.big-word {
            font-size: 0.46rem;
          }
        }

        .right-times-bottom {
          margin-top: 0.08rem;
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
          color: #fff;
        }
      }
    }

    .middle-word {
      margin-top: 0.35rem;
      font-family: Alibaba PuHuiTi, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      line-height: 0.15rem;
      text-align: center;
      color: #acab9c;
    }

    .btn {
      margin: 0.03rem auto 0 auto;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/VX2Cr2T4UZ.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      width: 3.24rem;
      height: 0.65rem;
    }

    .time {
      display: flex;
      justify-content: center;
      font-family: Alibaba PuHuiTi, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      line-height: 0.15rem;
      color: #acab9c;

      .haveBg {
        color: #693900;
        background: #acab9c;
        border-radius: 0.02rem;
        padding: 0 0.01rem;
      }

      .gc {
        color: #693900;
      }
    }
  }
}
</style>
